module.exports = __webpack_public_path__ + "img/High-tech Enterprise Certificate.d7407210.png";